import React, { HTMLAttributes } from 'react';

import {
  Container,
  WysiwygField,
} from '@uncinc/uncinc-react-kitchen-sink';
import { DynamicMediaItem } from '@uncinc/react-drupal-core';

import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';
import { ButtonWrapper } from '../../../components';
import { BlockCTA as Type } from '../../../types/uncinc_profile/blocks';

import './style.scss';

interface BlockCTAProps
  extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableEntity<Type>;
}

const BlockCTA: React.FC<BlockCTAProps> = ({ entity }) => {
  const paragraphEntity = entity.toJS();

  const title = paragraphEntity.info[0]?.value;
  const body = paragraphEntity.body[0]?.processed;
  const link = paragraphEntity.field_link[0];
  const linkTitle = link?.title;
  const linkUrl = link?.alias || link?.uri;
  const CTAImage = paragraphEntity.field_media[0];

  return (
    <Container>
      <div className="BlockCTA row">
        <div className="left col-12 col-md-5">
          <DynamicMediaItem
            className="BlockCTA__image"
            media={CTAImage}
            imageAspectRatio="3_4"
          />
        </div>
        <div className="gutterBackground" />
        <div className="right col-12 col-md-7">
          <div className="BlockCTA__content__container">
            <h2>{title}</h2>
            <WysiwygField html={body} />

            <ButtonWrapper href={linkUrl} className="BlockCTA__button Button--primary" wrapperTransparent>
              {linkTitle}
            </ButtonWrapper>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default BlockCTA;
